export function OffcanvasMenu() {
  document.addEventListener('DOMContentLoaded', () => {
    const drawer   = document.querySelector('.offcanvas-menu');
    if (!drawer) return;

    const panel    = drawer.querySelector('.offcanvas-panel');
    const tabs     = Array.from(drawer.querySelectorAll('.offcanvas-tab'));
    const sections = Array.from(drawer.querySelectorAll('.offcanvas-section'));
    const closeBtn = drawer.querySelector('.offcanvas-close');

    const header   = document.querySelector('.site-header');
    const burger   = document.querySelector('.menu-toggle');
    const content  = drawer.querySelector('.offcanvas-content');

    const htmlEl   = document.documentElement;
    const bodyEl   = document.body;
    let lockedScrollY = 0;

    const isMobile = () => window.matchMedia('(max-width: 76.8rem)').matches;

    const createBackButton = (section) => {
      const backBtn = section.querySelector('.offcanvas-back');
      if (!backBtn) return; // <-- fix null
      backBtn.addEventListener('click', () => {
        if (isMobile()) {
          content?.classList.add('d-none');
          drawer.classList.remove('is-subopen');
        }
      });
    };

    const showPanel = (id) => {
      tabs.forEach(t => {
        const active = t.dataset.target === id;
        t.classList.toggle('active', active);
        t.setAttribute('aria-expanded', String(active));
      });
      sections.forEach(s => {
        const isTarget = s.id === id;
        s.classList.toggle('d-none', !isTarget);
        if (isTarget && isMobile()) createBackButton(s);
      });
      sections.find(s => s.id === id)?.focus({ preventScroll: true });
    };

    const openDrawer = () => {
      drawer.classList.remove('d-none');
      drawer.setAttribute('aria-hidden', 'false');
      panel.style.transform = 'translateX(0)';
      header?.classList.add('full-color', 'offcanvas-menu-open');
      burger?.classList.add('is-open');
      htmlEl.classList.add('no-scroll');
      bodyEl.classList.add('no-scroll');

      const def = drawer.getAttribute('data-default-target');
      const first = def || (tabs[0]?.dataset.target ?? null);
      if (first) showPanel(first);

      if (isMobile()) {
        content?.classList.add('d-none');
        drawer.classList.remove('is-subopen');
      } else {
        content?.classList.remove('d-none');
        drawer.classList.remove('is-subopen');
      }
    };

    const closeDrawer = () => {
      drawer.setAttribute('aria-hidden', 'true');
      panel.style.transform = '';
      setTimeout(() => drawer.classList.add('d-none'), 300);
      header?.classList.remove('full-color', 'offcanvas-menu-open');
      burger?.classList.remove('is-open');
      drawer.classList.remove('is-subopen');
      content?.classList.add('d-none');
       htmlEl.classList.remove('no-scroll');
      bodyEl.classList.remove('no-scroll');
    };

    burger?.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = drawer.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.target;
        showPanel(targetId);

        if (isMobile()) {
          const targetSection = sections.find(s => s.id === targetId);
          const hasChildren = !!targetSection?.querySelector('.offcanvas-list li');
          if (hasChildren) {
            content?.classList.remove('d-none');
            drawer.classList.add('is-subopen');
          }
        }
      });
    });

    closeBtn?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  });
}